import axios from 'axios';

declare var APP_URL: any;

class ZefixConfigClass {

    legalForms: Object;
    registryOffices: Object;
    mutationTypes: Object;
    communities: Object;
    languageCodes: Object;
    localities: Object;

    private static _instance: ZefixConfigClass;

    constructor() {
        this.legalForms = localStorage.getItem('zefix_legalForms') ? JSON.parse(localStorage.getItem('zefix_legalForms')) : {};
        this.registryOffices = localStorage.getItem('zefix_registryOffices') ? JSON.parse(localStorage.getItem('zefix_registryOffices')) : {};
        this.mutationTypes = localStorage.getItem('zefix_mutationTypes') ? JSON.parse(localStorage.getItem('zefix_mutationTypes')) : {};
        this.communities = localStorage.getItem('zefix_communities') ? JSON.parse(localStorage.getItem('zefix_communities')) : {};
        this.languageCodes = localStorage.getItem('zefix_languageCodes') ? JSON.parse(localStorage.getItem('zefix_languageCodes')) : {};
        this.localities = localStorage.getItem('zefix_localities') ? JSON.parse(localStorage.getItem('zefix_localities')) : {};
    }

    public static getInstance()
    {
        return this._instance || (this._instance = new this());
    }

    public loadLocalConfig = async () => {
        let response = await axios.get(`${APP_URL}/zefixConfig.json`)

        let legalForms = {}
        for (let entry of response.data.legalForms) {
            legalForms[entry.id] = entry
        }
        localStorage.setItem('zefix_legalForms', JSON.stringify(legalForms));

        let registryOffices = {}
        for (let entry of response.data.registryOffices) {
            registryOffices[entry.id] = entry
        }
        localStorage.setItem('zefix_registryOffices', JSON.stringify(registryOffices));
        let mutationTypes = {}
        for (let entry of response.data.mutationTypes) {
            mutationTypes[entry.id] = entry
        }
        localStorage.setItem('zefix_mutationTypes', JSON.stringify(mutationTypes));

        let communities = {}
        for (let entry of response.data.communities) {
            communities[entry.id] = entry
        }
        localStorage.setItem('zefix_communities', JSON.stringify(communities));

        let languageCodes = {}
        for (let entry of response.data.languageCodes) {
            languageCodes[entry.id] = entry
        }
        localStorage.setItem('zefix_languageCodes', JSON.stringify(languageCodes));

        let localities = {}
        for (let entry of response.data.localities) {
            localities[entry.id] = entry
        }
        localStorage.setItem('zefix_localities', JSON.stringify(localities));

        this.legalForms = legalForms;
        this.registryOffices = registryOffices;
        this.mutationTypes = mutationTypes;
        this.communities = communities;
        this.languageCodes = languageCodes;
        this.localities = localities;
    }
};

export let ZefixConfig = ZefixConfigClass.getInstance();



// WEBPACK FOOTER //
// ./components/zefix-config.tsx